module.exports = __webpack_public_path__ + "img/shop.125a5519.svg";